const phase1 = {
  number: 1,
  title: "Foundation",
  weeks: "Weeks 1–4",
  dates: "Feb 18 – Mar 15",
  color: "#E8650A",
  light: "#FFF5EE",
  accent: "#C0500A",
  running: "Run/Walk intervals",
  hrTarget: "Zone 2: {Z2}",
  watchAlert: "Apple Watch alert: {Z2_MAX} bpm",
  weekData: [
    {
      week: 1,
      label: "Week 1",
      focus: "Learn the movements. Don't push pace.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "90s run / 60s walk × 12 reps (30 min)",
          note: "First session — focus on form over speed",
        },
        { day: "Tue", type: "rest", note: "Full rest or easy 20 min walk" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "A",
          run: "90s run / 60s walk × 12 reps (30 min)",
          note: "HR under {Z2_MAX} the whole time",
        },
        { day: "Thu", type: "rest", note: "Full rest or easy 20 min walk" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "B",
          run: "90s run / 60s walk × 12 reps (30 min)",
          note: "End of week 1 — well done",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        { day: "Sun", type: "rest", note: "Full rest" },
      ],
    },
    {
      week: 2,
      label: "Week 2",
      focus: "Same structure, 2 more reps. Notice HR recovering faster.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "90s run / 60s walk × 14 reps (35 min)",
          note: "2 extra reps vs last week",
        },
        { day: "Tue", type: "rest", note: "Full rest or walk" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "A",
          run: "90s run / 60s walk × 14 reps (35 min)",
          note: "Notice how quickly HR drops during walks",
        },
        { day: "Thu", type: "rest", note: "Full rest or walk" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "B",
          run: "90s run / 60s walk × 14 reps (35 min)",
          note: "HR recovery improving — good sign",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        { day: "Sun", type: "rest", note: "Full rest" },
      ],
    },
    {
      week: 3,
      label: "Week 3",
      focus: "Longer run intervals. Start to feel a rhythm.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "2min run / 45s walk × 12 (33 min)",
          note: "Longer run blocks — pace still easy",
        },
        { day: "Tue", type: "rest", note: "Full rest or walk" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "A",
          run: "2min run / 45s walk × 12 (33 min)",
          note: "Should feel more like running now",
        },
        { day: "Thu", type: "rest", note: "Full rest or walk" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "B",
          run: "2min run / 45s walk × 12 (33 min)",
          note: "3rd session of the week",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        { day: "Sun", type: "rest", note: "Full rest" },
      ],
    },
    {
      week: 4,
      label: "Week 4",
      focus: "Recovery week — reduce effort. First continuous 3-min blocks.",
      recovery: true,
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "3min run / 30s walk × 10 (35 min)",
          note: "Recovery week — KB sets down to 2",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "A",
          run: "3min run / 30s walk × 10 (35 min)",
          note: "Reduce KB sets to 2 this week",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "B",
          run: "3min run / 30s walk × 10 (35 min)",
          note: "End of Phase 1 — great progress!",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        { day: "Sun", type: "rest", note: "Full rest" },
      ],
    },
  ],
  workouts: {
    A: {
      name: "Workout A — Lower Body & Core",
      duration: "~25 min",
      exercises: [
        {
          name: "Glute Bridge",
          sets: "3 × 12",
          cue: "2 sec hold at top. Drive through heels. Knee-safe.",
          muscles: "Glutes, core",
        },
        {
          name: "Dead Bug",
          sets: "3 × 8 each",
          cue: "Lie on back. Slow & controlled. Lower back stays flat.",
          muscles: "Deep core",
        },
        {
          name: "Romanian Deadlift",
          sets: "3 × 10",
          cue: "Hip hinge, not squat. Feel hamstring stretch. Back flat.",
          muscles: "Hamstrings, glutes",
        },
        {
          name: "KB Row",
          sets: "3 × 10 each",
          cue: "Support on chair. Pull elbow to hip. Squeeze at top.",
          muscles: "Upper back",
        },
        {
          name: "Farmer Carry",
          sets: "3 × 20 steps each",
          cue: "Walk tall. Don't lean sideways. Brace your core.",
          muscles: "Core, grip",
        },
      ],
    },
    B: {
      name: "Workout B — Upper Body & Balance",
      duration: "~25 min",
      exercises: [
        {
          name: "Glute Bridge",
          sets: "3 × 12",
          cue: "Same as Workout A. Master this before moving on.",
          muscles: "Glutes, core",
        },
        {
          name: "Tall Kneeling Press",
          sets: "3 × 10 each",
          cue: "Kneel on towel. Press KB overhead. Core tight.",
          muscles: "Shoulders, core",
        },
        {
          name: "KB Halo",
          sets: "3 × 6 each dir",
          cue: "Slow and controlled. Full circle around head.",
          muscles: "Shoulders, mobility",
        },
        {
          name: "Single-Leg Deadlift",
          sets: "3 × 8 each",
          cue: "Touch wall for balance if needed. Hinge from hip.",
          muscles: "Glutes, balance",
        },
        {
          name: "Push-Up",
          sets: "3 × 10",
          cue: "On knees if needed. Chest to floor. Straight body line.",
          muscles: "Chest, triceps, core",
        },
      ],
    },
  },
  typeConfig: {
    "strength+run": { bg: "#FFF3E0", border: "#E8650A", label: "KB + Run", dot: "#E8650A" },
    rest: { bg: "#F5F5F5", border: "#CCCCCC", label: "Rest", dot: "#BBBBBB" },
  },
};

export default phase1;
